module.exports = __webpack_public_path__ + "img/the-netherlands-leukaemia-male.68f52608.png";